<template>
  <div
    class="main"
    data-app="true"
  >
    <v-app class="mx-auto">
      <v-container>
        <v-row justify="center">
          <v-col
            class="one-col-row-mobile"
            cols="8"
          >
            <p class="message">
              This information is intended for {{ firstName }}.
              If you are not this person, please call
              <a href="tel:+1877-392-2014">+1 (877) 392-2014</a> for assistance.
            </p>
          </v-col>
        </v-row>
        <v-form
          ref="form"
          v-model="isVerificationFormValid"
          class="validation-border"
          @submit.prevent="submit"
        >
          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                v-model="firstName"
                label="First Name"
                filled
                readonly
                class="input_field"
              >
                <template
                  v-slot:append
                >
                  <v-icon class="mdi mdi-check"/>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              class="last-name-col"
              cols="5"
            >
              <v-text-field
                v-model="lastName"
                label="Last Name"
                class="input_field"
                filled
                readonly
              >
                <template
                  v-slot:append
                >
                  <v-icon class="mdi mdi-check"/>
                </template>
              </v-text-field>
            </v-col>
            <v-col
              class="suffix-col"
              cols="3"
            >
              <v-select
                v-model="form.suffix"
                :items="suffixes"
                label="Suffix"
                class="input_field"
                filled
                hide-details="auto"
              />
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                v-model="form.dob"
                v-mask="'##-##-####'"
                class="dob_input input_field"
                label="Date of Birth: MM-DD-YYYY"
                hide-details="auto"
                :rules="rules.dobCheck"
                filled
                required
                validate-on-blur
                @input="clearDoB"
              >
                <template
                  v-if="form.dob"
                  v-slot:append
                >
                <v-icon
                    v-if="!DoBError && dateOfBirthValid()"
                    class="mdi mdi-check"
                  />
                  <v-icon
                    v-else
                    class="mdi mdi-close"
                  />
                </template>
              </v-text-field>
              <p
                v-show="DoBError"
                class="submit-error"
              >{{
                DoBErrorMessage
              }}</p>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col
              class="one-col-row-mobile"
              cols="8"
            >
              <v-text-field
                v-model="form.ssn"
                v-mask="'###-##-####'"
                class="ssn_input input_field"
                label="SSN"
                :rules="rules.ssnCheck"
                hide-details="auto"
                filled
                required
                :type="showSSN ? 'text' : 'password'"
                :append-icon="showSSN ? 'mdi-eye' : 'mdi-eye-off'"
                validate-on-blur
                @click:append="showSSN = !showSSN"
                @input="clearSSN"
                @paste.prevent
              />
              <p
                v-show="SSNError"
                class="submit-error"
              >{{
                SSNErrorMessage
              }}</p>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col
              cols="6"
              class="secure one-col-row-mobile"
            >
              <img
                class="secure_shield"
                src="../../../../assets/images/icon-SecureAuthorization.png"
              >
              <div>
                Your information is secured with SSL and 128-bit encryption.
              </div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col
              cols="12"
              align="center"
              class="one-col-row-mobile"
            >
              <v-btn
                x-large
                color="#007EB1"
                class="confirm-btn"
                type="submit"
                :disabled="submitPressed"
              >
                Confirm Identity
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import router from './DMOfferCodeRouter';

export default {
  name: 'VerificationForm',
  data() {
    return {
      form: {
        ssn:    '',
        dob:    '',
        suffix: '',
      },
      suffixes: ['', 'Jr.', 'Sr.', 'I', 'II', 'III', 'IV', 'V'],

      // eslint-disable-next-line max-len
      dobRegEx: /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)[0-9]{2}/,
      rules: {
        dobCheck: [
          (val) => !!val || 'This field is required.',
          (val) => this.dateOfBirthValid(val) || 'Enter a valid date of birth.',
        ],
        ssnCheck: [
          (val) => !!val || 'This field is required.',
          (val) => val.length == 11 ||
            'Enter your 9-digit social security number.',
        ],
      },
      showSSN: false,

      DoBError: false,
      SSNError: false,
      DoBErrorMessage: '',
      SSNErrorMessage: '',
      isVerificationFormValid: false,
      submitPressed: false,
    };
  },

  computed: {
    ...mapGetters([
      'firstName',
      'lastName',
      'ssnMatch',
      'dobMatch',
    ]),
  },

  methods: {
    ...mapActions([
        'verifyOffer',
      ]),

    dateOfBirthValid(dob = this.form.dob) {
      return this.dobRegEx.test(dob);
    },

    clearDoB() {
      if (this.DoBError) {
        this.DoBError = false;
        this.DoBErrorMessage = '';
      }
    },

    clearSSN() {
      if (this.SSNError) {
        this.SSNError = false;
        this.SSNErrorMessage = '';
      }
    },

    DoBErrorCheck(){
      this.DoBError = !this.dobMatch;
      this.DoBErrorMessage = "This doesn't match our records."
    },

    SSNErrorCheck(){
      this.SSNError = !this.ssnMatch;
      this.SSNErrorMessage = "This doesn't match our records."
    },

    isReadyToSubmit() {
      return (this.isVerificationFormValid && !(this.DoBError || this.SSNError))
    },

    async submit() {
      if (this.submitPressed) { return };
      this.$refs.form.validate();
      if (!this.isReadyToSubmit()) { return }

      this.submitPressed = true;
      let payload = {'ssn': this.form.ssn, 'dob': this.form.dob}
      await this.verifyOffer(payload);

      this.DoBErrorCheck()
      this.SSNErrorCheck()
      if (this.isReadyToSubmit()){
        this.$store.commit('ADD_VERIFICATION_PAGE_DATA', this.form);
        router.push('/apply');
      }
      this.submitPressed = false;
    },
  },
};
</script>

<style scoped lang="scss">
.one-col-row-mobile {
  @media (max-width: 450px) {
    font: normal normal bold 16px/25px Open Sans;
    max-width: 100%;
    flex: 100%;
  }
}

.last-name-col {
  @media (max-width: 450px) {
    font: normal normal bold 16px/25px Open Sans;
    max-width: 60%;
    flex: 60%;
  }
}

.suffix-col {
  @media (max-width: 450px) {
    font: normal normal bold 16px/25px Open Sans;
    max-width: 39%;
    flex: 39%;
  }
}

.message {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    18px/25px var(--unnamed-font-family-open-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-333333);
  text-align: left;
  font: normal normal bold 18px/25px Open Sans;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
}

.submit-error {
  font-size: 12px;
  color: #DB2435 !important;
  caret-color: #DB2435 !important;
  text-align: right;
  word-break: break-word;
}

::v-deep .v-messages__message {
  text-align: right;
}
.mdi-close:before {
  color: #DB2435;
}
.mdi-check::before {
  color: #4EBB85;
}

.validation-border {
  ::v-deep .v-input__slot {
    border: 1px solid #A9A9A9 !important;
    background: #ffffff !important;
    
    fieldset {
      border: 1px solid #A9A9A9;
      background: #ffffff;
    }

    &:before, &:after {
      display: none;
    }
  }
  ::v-deep .v-input--has-state .v-input__slot{
    border: 1px solid #DB2435 !important;
  }
  ::v-deep .v-text-field__details {
    margin-bottom: 0px;
  }
  ::v-deep .primary--text{
    color: #007EB1 !important;
    caret-color: #333333 !important;
  }
  ::v-deep .error--text{
   color: #DB2435 !important;
   caret-color: #333333 !important;
  }
}

.input_field {
   border-radius: 5px;
   opacity: 1;
   color: #A9A9A9;
}

.secure {
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) 18px/25px
    var(--unnamed-font-family-open-sans);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-333333);
  font: normal normal normal 18px/25px Open Sans;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  display: flex;
  float: left;
  @media (max-width: 450px) {
    font: normal normal normal 16px/25px Open Sans;
  }
}

.secure_shield {
  width: 42px;
  height: 45px;
  margin-right: 25px;
}

.confirm-btn {
  color: #ffffff;
  border-radius: 5px;
  opacity: 1;
  background: #007eb1;
  border: 2px solid #007eb1;
  ::v-deep .v-btn__content {
    font-size: 26px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: center;
    text-transform: none;
    padding: 0px 33px;
  }
  &:hover,
  &:focus {
    background: #016c98;
    border: 2px solid #016c98;
  }
  &:active {
    box-shadow: 0 0 8px #007eb1;
    background-color: #007eb1 0% 0% no-repeat padding-box;
    border: 2px solid #007eb1;
    color: #ffffff;
  }
  &:disabled {
    background-color: #d7d7d7 0% 0% no-repeat padding-box;
    border: 2px solid #d7d7d7;
    color: #333333 !important;
  }
  @media (max-width: 375px) {
    max-width: 95%;
  }
}
</style>
